angular.module('gettext').run(['gettextCatalog', function (gettextCatalog) {
  gettextCatalog.setStrings('as_AS', require('./as.json'))
  gettextCatalog.setStrings('es_ES', require('./es.json'))
  gettextCatalog.setStrings('de_AT', require('./at.json'))
  gettextCatalog.setStrings('de_CH', require('./ch.json'))
  gettextCatalog.setStrings('de_DE', require('./de.json'))
  gettextCatalog.setStrings('en_GB', require('./en.json'))
  gettextCatalog.setStrings('en_IE', require('./ie.json'))
  gettextCatalog.setStrings('fr_FR', require('./fr.json'))
  gettextCatalog.setStrings('sd_IE', require('./sd.ie.json'))
  gettextCatalog.setStrings('sd_SD', require('./sd.json'))
}])
